export function isValidEmail(email: string): boolean {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email.trim());
}

export const validatePostalCode = (input: string) => {
  // postal codes do not include D, F, I, O, Q, or U, and first position cannot be W or Z
  // space in fourth position is optional
  // https://www150.statcan.gc.ca/n1/pub/92-154-g/2015001/tech-eng.htm
  const regex = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]\d[ABCEGHJ-NPRSTV-Z]\d$/i;
  return regex.test(input);
};
